import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import AppUtils from '../../../utils/AppUtils'
import AppConstants from '../../../utils/AppConstants'
import ColumnsProvider from '../../../utils/ColumnsProvider'
import Popup from '../../../components/elements/Popup'
import Header from '../../../components/elements/Header'
import Table from '../../../components/elements/Table'
import LocationStickers from '../../../components/elements/LocationStickers'
import Properties from '../../../components/elements/Properties'
import Details from '../../../components/elements/Details'

import GetAction from '../../../actions/items/GetHistoryAction'
import ChangePageAction from '../../../actions/app/ChangePageAction'

class HistoryItemPopup extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // Bind events
    this.onClickGoToInventory = this.onClickGoToInventory.bind(this)
    this.onClickGoToExecution = this.onClickGoToExecution.bind(this)
    this.onClickGoToMaintenance = this.onClickGoToMaintenance.bind(this)
  }

  componentDidMount() {
    this.props.fetch(this.props.id)
  }

  componentDidUpdate(prevProps, prevState) {
    // When error in fetch, close
    if (
      prevProps.isFetching
      &&
      !this.props.isFetching
      &&
      this.props.error
    ) {
      AppUtils.setStatus(
        AppConstants.STATUS.TYPE.FAILURE,
        AppUtils.errorToText(this.props.error)
      )
      this.props.onClose()
    }
  }

  onClickGoToInventory(id) {
    return () => {
      this.props.changePage(AppConstants.PAGE.INVENTORY, { id })
      setTimeout(() => { this.props.onClose() }, 0)
    }
  }

  onClickGoToExecution(idStr) {
    return () => {
      const idArr = idStr.split(':')
      const id = Number(idArr[0])
      const execution = Number(idArr[1])
      this.props.changePage(AppConstants.PAGE.MAINTENANCE_VIEW, { id, execution })
      setTimeout(() => { this.props.onClose() }, 0)
    }
  }

  onClickGoToMaintenance(id) {
    return () => {
      this.props.changePage(AppConstants.PAGE.MAINTENANCE_VIEW, { id })
      setTimeout(() => { this.props.onClose() }, 0)
    }
  }

  render() {
    return (
      <Popup
        header="Historique d'une pièce"
        body={
          this.props.data
            ? <React.Fragment>
                <Properties
                  content={_.union(
                    [{
                      key: 'Matériel',
                      value: this.props.data.product.name || '-'
                    }],
                    this.props.data.number
                      ? [{
                          key: 'N°',
                          value: (
                            <span>
                              {this.props.data.number}
                              {' '}
                              {
                                !this.props.data.isuniquelabeled
                                  ? <Details
                                      icon={Details.ICON.WARNING}
                                      action={Details.ACTION.HOVER}
                                      content='Etiquettage incomplet'
                                    />
                                  : null
                              }
                            </span>
                          )
                        }]
                      : [],
                    [
                      {
                        key: 'Emplacement',
                        value: (
                          <span>
                            <LocationStickers
                              stickers={this.props.data.location.stickers}
                            />
                            {' '}
                            {
                              !this.props.data.islabeled
                                ? <Details
                                    icon={Details.ICON.WARNING}
                                    action={Details.ACTION.HOVER}
                                    content='Etiquettage incomplet'
                                  />
                                : null
                            }
                          </span>
                        )
                      },
                      {
                        key: 'Compartiment',
                        value: this.props.data.compartment || '-'
                      },
                      {
                        key: 'Remarque',
                        value: this.props.data.remark || '-'
                      }
                    ]
                  )}
                />
                <Header title='Historique' />
                <div style={{
                  maxHeight: '240px',
                  display: 'flex',
                  flexDirection: 'column'
                }}>
                  <Table
                    columns={[
                      // Date
                      ColumnsProvider.genericDate,
                      // Evénement
                      ColumnsProvider.itemHistoryEvent,
                      // Actions
                      ColumnsProvider.itemHistoryAction(this)
                    ]}
                    data={this.props.data.history.events}
                    error={null}
                    isLoading={false}
                    emptyMessage="Aucun événement à afficher."
                    float={true}
                  />
                </div>
                <Header title='Maintenance' />
                <div style={{
                  maxHeight: '120px',
                  display: 'flex',
                  flexDirection: 'column'
                }}>
                  <Table
                    columns={[
                      // Nom
                      ColumnsProvider.genericName,
                      // Dernière
                      ColumnsProvider.maintenanceLast,
                      // Prochaine
                      ColumnsProvider.maintenanceNextWithDetails(true),
                      // Action
                      ColumnsProvider.actionGoTo(this.onClickGoToMaintenance)
                    ]}
                    data={this.props.data.history.maintenances}
                    error={null}
                    isLoading={false}
                    emptyMessage="Aucune maintenance pour ce matériel."
                    float={true}
                  />
                </div>
              </React.Fragment>
            : null
        }
        footer={[
          {
            type: Popup.BUTTONTYPE.CLOSE,
            title: 'Fermer',
            icon: 'close',
            onClick: () => { this.props.onClose() }
          }
        ]}
        isLoading={this.props.isFetching}
      />
    )
  }
}

HistoryItemPopup.propTypes = {
  // Properties
  id: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,

  // Redux State
  data: PropTypes.object,
  isFetching: PropTypes.bool.isRequired,
  error: PropTypes.object,

  // Redux Actions
  fetch: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    data: state.entities.items.get.history.data,
    isFetching: state.entities.items.get.history.isFetching,
    error: state.entities.items.get.history.error
  }),
  (dispatch) => ({
    fetch: (id) => (dispatch(GetAction({ id }))),
    changePage: (page, payload={}) => (dispatch(ChangePageAction(page, payload)))
  })
)(HistoryItemPopup)



// WEBPACK FOOTER //
// ./src/containers/popups/items/HistoryItemPopup.js